<template>
	<modal
		:title="title"
		:active="active"
		:dismissable="true"
		@dismiss="dismiss"
	>

		<modal-body>
			<p v-if="group">
				You will still have access to {{group.reportName}}'s dashboards as a member, but you won't be able to manage it's dashboards, users or group settings.
            </p>
		</modal-body>

		<modal-actions>
			<btn primary @click="onRevoke">Revoke access</btn>
			<btn link @click="cancel">Cancel</btn>
		</modal-actions>
		
	</modal>
</template>


<script>
    import { ModalMixin } from 'pdk/mixins';
	

	export default {
		name: 'revoke-group-admin-access-modal',
		mixins: [ModalMixin],
		props: {
            group: {
                type: Object,
                required: true
            }
		},
        computed: {
            title() {
                if (!this.group) return null;
				return `Revoke group admin access from ${this.group.reportName}?`;
			}
		},
		methods: {
			onRevoke() {
                this.$emit('revoke', this.group);
                this.close();
			}
		}
	};
</script>
